// Status do pedido (docs/api.md 2.4): id numérico ↔ texto em português
export const ORDER_STATUS_BY_NAME = {
  Aguardando: 0,
  Preparando: 1,
  Liberado: 2,
  Entregue: 3,
  Finalizado: 4,
  Cancelado: 5,
};

/**
 * Normaliza a resposta de GET /orders/{code}/status (ou do WebSocket) para o id 0–5.
 * A API devolve número puro, mas aceita também { status }, { data: { status } },
 * { data: [{ status }] } e o texto ("Preparando").
 * Retorna null se não for possível extrair um status válido.
 */
export const parseOrderStatus = (data) => {
  let raw = data;
  if (raw && typeof raw === "object") {
    const inner = Array.isArray(raw.data) ? raw.data[0] : raw.data;
    raw = raw.status ?? inner?.status ?? inner;
  }

  if (typeof raw === "string" && raw.trim() !== "") {
    if (ORDER_STATUS_BY_NAME[raw] !== undefined) return ORDER_STATUS_BY_NAME[raw];
    raw = Number(raw);
  }

  return Number.isInteger(raw) && raw >= 0 && raw <= 5 ? raw : null;
};
